import { Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import * as AOS from 'aos';
import { UiService } from './services/ui.service';
import {TranslateService} from '@ngx-translate/core';
import { GenericButtonTextEnum } from './misc/enums';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'akiba';

  constructor(private swUpdate: SwUpdate, private ui: UiService, private translate: TranslateService) {
    this.translate.addLangs(['es-mx', 'es-pe']);
    this.translate.setDefaultLang('es-mx');
    this.translate.use('es-mx');
  }

  ngOnInit() {
    // Para las animaciones de la landing :)
    AOS.init();

    if (this.swUpdate.isEnabled) {
      this.swUpdate.available.subscribe(() => {
        this.confirmUpdateVersion();
      });

      this.swUpdate.checkForUpdate();
    }
  }

  async confirmUpdateVersion(): Promise<void> {
    const confirm = await this.ui.showConfirmMessage(
      'Hay una nueva versión disponible. Se actualizará la página para concluir la actualización.', GenericButtonTextEnum.Cancel, GenericButtonTextEnum.Accept
    );
    if (confirm) {
      window.location.reload();
    }
  }
}
